import { Sun, Moon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { IconButton } from '@/components/ui/icon-button';
import { useDarkMode } from '@/hooks/use-dark-mode';

export function ThemeToggle({ fixed = false }: { fixed?: boolean }) {
  const { t } = useTranslation();
  const { isDark, toggle } = useDarkMode();

  return (
    // `IconButton`, not `Button`: an icon with no label is the one case the labelled button is not
    // for. It also drops the hard-coded English name this carried, and names what pressing it WILL
    // do rather than what it is — "Switch to light mode" beats "Toggle theme" when the only other
    // clue is a sun.
    <IconButton
      variant='default'
      size='sm'
      onClick={toggle}
      aria-label={isDark ? t('common.toggleLightMode') : t('common.toggleDarkMode')}
      className={fixed ? 'fixed right-4 top-4 z-50' : ''}
    >
      {isDark ? <Sun className='h-4 w-4' /> : <Moon className='h-4 w-4' />}
    </IconButton>
  );
}
